import { useCrumbs } from "@/components/layout/CrumbsContext";
import { FlagsView } from "@/components/plan-audit/FlagsView";
import { useRun } from "@/hooks/use-plan-audit";

export function FlagsPage({ reference }: { reference: string }) {
  const { data: run } = useRun(reference);
  useCrumbs([
    { label: "Solutions", to: "/solutions" },
    ...(run === undefined
      ? [{ label: reference }]
      : [
          { label: run.solution.name, to: `/solutions/${run.solution.slug}` },
          { label: `run ${run.reference}`, to: `/runs/${run.reference}` },
          { label: "Flags" },
        ]),
  ]);
  return <FlagsView reference={reference} />;
}
